import React from "react";
import { Box, Grid, Typography, TextField, Button, IconButton, Autocomplete, FormGroup, FormControlLabel, Checkbox, Divider } from "@mui/material";
import Map from "../../../components/Map";
import { Add, Close, DeleteForeverOutlined } from "@mui/icons-material";

export default function AddZone(props) {

  return (
    <Box component="form" onSubmit={props.handleSubmit} sx={{ p: 3 }}>
      <Grid container spacing={3} sx={{ placeContent: "center" }}>
        <Grid item xs={6}>
          <Typography variant="subtitle1" color="primary" className="font-bold m-2 font-gray">
            {props.btn} {props.literals.zone}
          </Typography>
        </Grid>
        <Grid item xs={6} align='right'>
          <IconButton color="primary" aria-label="upload picture" component="label" onClick={props.onClose}>
            <Close />
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            blurOnSelect
            options={props.cities}
            getOptionLabel={(option) => option.city_name + ' - ' + (option.org?.org_name)}
            value={props.selectedCity}
            onChange={(event, newValue) => props.setSelectedCity(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                // sx={{width: smDown ? 200 : 300, backgroundColor: '#fff'}}
                label={props.literals.select_city}
                variant='outlined'
                size='small'
                InputProps={{
                  ...params.InputProps,
                  type: 'search',
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="standard-error-helper-text"
            label={props.literals.zone_name}
            color="primary"
            type="text"
            name="zone_name"
            value={props.inputField["zone_name"]}
            onChange={props.handleChange}
            size="small"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel control={
              <Checkbox
                name="tenant_zone"
                onChange={props.handleCheck}
                checked={props.inputField['tenant_zone']}
              />} label={
                <Typography variant="subtitle1" color="primary" className="font-gray">
                  {props.literals.tenant_zone}
                </Typography>
              } />
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>
            <FormControlLabel control={
              <Checkbox
                name="is_plate_editable"
                onChange={props.handleCheck}
                checked={props.inputField['is_plate_editable']}
              />} label={
                <Typography variant="subtitle1" color="primary" className="font-gray">
                  {props.literals.is_plate_editable}
                </Typography>
              } />
          </FormGroup>
        </Grid>
        <Grid item xs={8}>
          {props.inputField.is_plate_editable && <TextField
            label={props.literals.no_of_times_plate_can_edit}
            color="primary"
            type="number"
            name="no_of_times_plate_can_edit"
            value={props.inputField["no_of_times_plate_can_edit"]}
            onChange={props.handleChange}
            size="small"
            required
            fullWidth
          />}
        </Grid>
        <Grid item xs={12}>
          <FormGroup>
            <FormControlLabel control={
              <Checkbox
                name="add_caption"
                onChange={props.handleCheck}
                checked={props.inputField['add_caption']}
              />} label={
                <Typography variant="subtitle1" color="primary" className="font-gray">
                  {props.literals.add_caption}
                </Typography>
              } />
          </FormGroup>
        </Grid>
        {props.inputField['add_caption'] && <>
          <Grid item xs={12}>
            <Typography variant="subtitle1" color={'primary'}>{props.literals.caption_en}*</Typography>
            <textarea
              type="text"
              name="caption_en"
              value={props.inputField["caption_en"]}
              onChange={props.handleChange}
              maxlength="100"
              required
              style={{ width: '100%', height: '54px', border: '1px solid rgb(196, 196, 196)', borderRadius: '5px' }}
            ></textarea>
            <Grid align="end">
              <Typography variant="caption" sx={{ color: 'rgb(196, 196, 196)' }}>{props.inputField['caption_en']?.length || 0}/100</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" color={'primary'}>{props.literals.caption_fr}*</Typography>
            <textarea
              type="text"
              name="caption_fr"
              value={props.inputField["caption_fr"]}
              onChange={props.handleChange}
              maxlength="100"
              required
              style={{ width: '100%', height: '54px', border: '1px solid rgb(196, 196, 196)', borderRadius: '5px' }}
            ></textarea>
            <Grid align="end">
              <Typography variant="caption" sx={{ color: 'rgb(196, 196, 196)' }}>{props.inputField['caption_fr']?.length || 0}/100</Typography>
            </Grid>
          </Grid>
        </>}
        <Grid item xs={12}>
          {!props.taxes.length && <Button
            type="button"
            color="primary"
            variant="contained"
            onClick={props.addTax}
            size="small"
            sx={{ mx: 2 }}>
            {props.literals.add_tax}
          </Button>}
          <Grid container spacing={2} sx={{ placeContent: "center" }}>
            {props.taxes.map((el, index) => {
              return (
                <>
                  <Grid item xs={6} align="start" alignSelf="center">
                    <Typography variant="subtitle1" color="primary">
                      {props.literals.tax} {(index + 1)}.
                    </Typography>
                  </Grid>
                  <Grid item xs={6} align="end">
                    {props.taxes.length == (index + 1) && <IconButton
                      type="button"
                      color="primary"
                      variant="outlined"
                      onClick={props.addTax}>
                      <Add />
                    </IconButton>}
                    {props.taxes.length !== 1 && <IconButton
                      type="button"
                      color="primary"
                      variant="outlined"
                      onClick={() => props.delTax(index)}>
                      <DeleteForeverOutlined />
                    </IconButton>}
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id={index}
                      label={props.literals.tax_name}
                      color="primary"
                      type="text"
                      name="tax_name"
                      value={el.tax_name}
                      onChange={props.handleTaxChange}
                      size="small"
                      required
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id={index}
                      label={props.literals.tax_percentage}
                      color="primary"
                      type="number"
                      name="tax_percentage"
                      value={el.tax_percentage}
                      onChange={props.handleTaxChange}
                      size="small"
                      required
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormGroup>
                      <FormControlLabel sx={{ color: "#000000de" }} control={
                        <Checkbox
                          id={index}
                          checked={el.tax_included === true}
                          color="primary"
                          onChange={props.handleTaxChange}
                          value={el.tax_included}
                          size="small"
                          name="tax_included"
                        />} label={props.literals.tax_included} />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider color="primary" />
                  </Grid>
                </>
              )
            }
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Map
            center={props.center}
            zoom={props.zoom}
            polygon={props.polygon}
            height={'80vh'}
            editable={true}
            literals={props.literals}

            setPolygon={(e) => props.setPolygon(e)}
            setCenter={(e) => props.setCenter(e)}
            setZoom={(e) => props.setZoom(e)}
          />
        </Grid>
        <Grid item xs={12} align="right">
          <Button
            type="button"
            color="secondary"
            variant="contained"
            onClick={props.onClose}
            size="small"
            sx={{ mx: 2 }}>
            {props.literals.cancel}
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            size="small">
            {props.btn}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
